export enum ApplicationFlagsEnum {
    App = 1 << 0,
    Premium = 1 << 1,
    Admin = 1 << 2,
}
